// extracted by mini-css-extract-plugin
module.exports = {"WithFormatting":"HTMLText_WithFormatting__PjdIV","ContentButton":"HTMLText_ContentButton__s5IlW"};